import { render } from "./AddCategorieAbonneModal.vue?vue&type=template&id=6fbb7099&ts=true"
import script from "./AddCategorieAbonneModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieAbonneModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__